import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FormControl, InputLabel } from "@mui/material";
import { DataTypesList } from "../../types/constant";

export default function EtimDataType(props) {
  const { label, value, onChange, disabled } = props;

  return (
    <>
      <FormControl fullWidth size="small">
        <InputLabel id="etimType">{label}</InputLabel>
        <Select
          value={value}
          onChange={onChange}
          labelId="etimType"
          name="role"
          label={label}
          disabled={disabled}
          defaultValue=""
          fullWidth
        >
          {DataTypesList.map((m, i) => (
            <MenuItem key={`${m}_${i}`} value={m}>
              {m}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}
